module.exports = __webpack_public_path__ + "icoBank.png";